// components/Hero.js
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Pill, Shield, Truck } from 'lucide-react';

const Hero = () => {
  return (
    <div className="relative bg-gradient-to-r from-primary-dark/90 to-primary/90 min-h-[70vh] md:h-[70vh] flex items-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0 opacity-100"
        style={{
          backgroundImage: "url('/images/Pharma_img1.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>
      
      <div className="container-custom relative z-10 py-6 md:py-8 lg:py-10 w-full">
        <div className="max-w-3xl">
          {/* <div className="inline-block bg-white/20 backdrop-blur-sm rounded-full px-4 py-1 mb-4 md:mb-5 border border-black/40">
            <span className="text-[#00594A] text-xs md:text-sm font-semibold">Trusted Since 2010</span>
          </div> */}
          
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#032923] leading-tight mb-3 md:mb-4">
            Your Trusted <span className="text-[#07E2F2]">Pharmaceutical</span> Partner
          </h1>
          
         <p className="text-gray-800 text-sm md:text-base lg:text-[17px] font-light tracking-tight leading-relaxed mb-4 md:mb-6 max-w-2xl">
  Quality medicines, reliable distribution, and healthcare solutions for Gondia and beyond. Serving medical professionals and patients with excellence.
</p>
          
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mb-6 md:mb-8">
            <Link 
              to="/contact" 
              className="bg-[#07A0F2] text-white hover:bg-gray-100 hover:text-black px-5 py-2.5 md:px-6 md:py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition duration-300 shadow-lg text-sm md:text-base"
            >
              Get In Touch <ArrowRight size={18} />
            </Link>
            <Link 
              to="/products" 
              className="border-2 border-black text-black hover:bg-white/10 px-5 py-2.5 md:px-6 md:py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition duration-300 text-sm md:text-base"
            >
              Explore Products
            </Link>
          </div>
          
          {/* Stats */}
          <div className="grid grid-cols-3 gap-3 md:gap-4 pt-4 md:pt-6 border-t border-white/20">
            <div className="text-center">
              <div className="flex justify-center mb-1 md:mb-2">
                <Pill className="text-black" size={20} />
              </div>
              <div className="text-black text-lg md:text-xl font-bold">50+</div>
              <div className="text-black text-xs md:text-sm">Products</div>
            </div>
            <div className="text-center">
              <div className="flex justify-center mb-1 md:mb-2">
                <Shield className="text-black" size={20} />
              </div>
              <div className="text-black text-lg md:text-xl font-bold">100%</div>
              <div className="text-black text-xs md:text-sm">Genuine Quality</div>
            </div>
            <div className="text-center">
              <div className="flex justify-center mb-1 md:mb-2">
                <Truck className="text-black" size={20} />
              </div>
              <div className="text-black text-lg md:text-xl font-bold">24/7</div>
              <div className="text-black text-xs md:text-sm">Supply Chain</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;